import { Injectable } from "@angular/core";

import { SQLite, SQLiteObject } from "@ionic-native/sqlite";
//import { SQLiteObject } from './sqlliteobject.service';

@Injectable()
export class SqlLiteService {
    public database: SQLiteObject;

    constructor(private sqlite: SQLite) {}

    bootup() {
        console.log("Coming to bootup");

        let self = this;

        // Create a databse for mymily local db
        // Create a table for database
        this.createDatabaseEntry(function(response) {
            // Created

            console.log("Created DB");
            self.createTable(function(response) {
                console.log("Created Table");
            });
        });
    }

    listItems(key, cateory, callback) {
        let temp: any = {};

        this.database
            .executeSql("SELECT * FROM orders", temp)
            .then(res => {
                let results = [];
                let len = res.rows.length,
                    i,
                    parsedData;

                for (i = 0; i < len; i++) {
                    parsedData = JSON.parse(res.rows.item(i).data);

                    results.push({
                        key: res.rows.item(i).key,
                        category: res.rows.item(i).category,
                        data: parsedData
                    });
                }

                callback(results);
            })
            .catch(e => console.log(e));
    }

    createDatabaseEntry(callback) {
        let self = this;

        this.sqlite
            .create({ name: "gp_field_app.db", location: "default" })
            .then(
                (db: SQLiteObject) => {
                    self.database = db;
                    callback(db);
                },
                error => {
                    console.log("ERROR: ", error);
                }
            );
    }

    createTable(callback) {
        let temp: any = {};

        this.database
            .executeSql(
                "CREATE TABLE IF NOT EXISTS coordinates( \
                timestamp TEXT NOT NULL, \
                user_id VARCHAR(100) NOT NULL, \
            lat VARCHAR(100) NOT NULL, \
            lng VARCHAR(100) NOT NULL)",
                temp
            )
            .then(() => {
                console.log("Table coordinates created !");

                callback();
            })
            .catch(e => console.log(e));
    }

    connect() {
        // Connect to database
        // Create the table if it doesnt exists
        // save the Database connection in the class variable
    }

    disconnect() {
        // Disconnect from database
        // Database connection should be disconnected
    }

    shutdown() {
        // Shutdown the complete database
        // Delete the files
        let self = this;

        try {
            self.sqlite
                .deleteDatabase({
                    name: "gp_field_app.db",
                    location: "default"
                })
                .then(
                    (db: SQLiteObject) => {},
                    error => {
                        console.log("ERROR: ", error);
                    }
                );
        } catch (err) {
            console.log("ERROR: deleting DB");
        }
    }

    getCoordinatesItem(callback) {
        let query = "SELECT * FROM coordinates";

        this.database
            .executeSql(query, null)
            .then(res => {
                let results = [];
                let len = res.rows.length,
                    i;

                for (i = 0; i < len; i++) {
                    results.push({
                        timestamp: res.rows.item(i).timestamp,
                        lat: parseFloat(res.rows.item(i).lat),
                        lng: parseFloat(res.rows.item(i).lng),
                        user_id: parseInt(res.rows.item(i).user_id)
                    });
                }

                callback(results);
            })
            .catch(e => console.log(e));
    }

    addOrordinates(lat, lng, callback) {
        let timestamp: any = new Date().valueOf() / 1000 + 19800;
        timestamp = timestamp.toString();

        let user_id = localStorage.getItem("user-id");

        this.database
            .executeSql(
                "INSERT INTO coordinates( \
                    timestamp,\
                     user_id,\
                    lat,\
                    lng\
                    ) VALUES(?,?,?,?)",
                [timestamp, user_id, lat, lng]
            )
            .then(
                response => {
                    callback(response);
                },
                err => {
                    console.log(err);
                }
            );
    }

    removeCoordinates(callback) {
        // Take the keys & remove the same from the table
        // While removing, remove the particular key & the page number
        // When page number is not set, all the pages are being deleted

        let query = "DELETE FROM coordinates";

        this.database
            .executeSql(query)
            .then(res => {
                callback(res);
            })
            .catch(e => console.log(e));
    }
}



// WEBPACK FOOTER //
// ./src/common/services/sqllite.service.ts